export enum modalViewType {
  form = 'form',
  success = 'success',
  error = 'error',
  existingClientList = 'existingClientList',
}

export const zipcodeCountyEndpoint = '/api/broker-portal/locations/zipcodes/';

export const validZipcodeProps = ['zip_code', 'zipcode'];

export const validCountyProp = 'county';

export const countyOption = [{ label: 'Select One', value: null }];

export const countyList = 'counties';
